<template>
    <div class="container login-container">
        <div class="d-flex justify-content-center align-items-center flex-column login-page-main-wrapper">
            <div class="row justify-content-center login-form-wrapper">
                <div class="col-md-7 login-right d-flex align-items-center">
                    <div class="users-style">
                        <template v-if="hostname != 'secure.accordhrm.com'">
                            <span class="vendor-logo-wrapper">
                                <img :src="$api_url+'/images/landing-page/'+replaceDotWithUnerscore(hostname)+'.png'" class="brac-bank-logo" :alt="hostname">
                            </span>
                        </template>
                        <p class="text-center mb-0 login-title">Set <span class="light-green-text">New Password</span></p>  
                        <b-form @submit.stop.prevent="onSubmit">

                            <b-form-group id="password-group" label="Password" label-for="password">
                                <b-form-input id="password" name="password" placeholder="Password" type="password" autocomplete="off" v-model="fdata.password" v-validate="{ required: true, min: 8 }" :state="validateState('password')" aria-describedby="password-feedback" data-vv-as="Password"></b-form-input>
                                <b-form-invalid-feedback id="password-feedback">{{ veeErrors.first('password') }}</b-form-invalid-feedback>
                            </b-form-group>

                            <b-form-group id="password_confirmation-group" label="Confirm Password" label-for="password_confirmation" >
                                <b-form-input id="password_confirmation" name="password_confirmation" placeholder="Password Confirmation" type="password" autocomplete="off" v-model="fdata.password_confirmation" v-validate="{ required: true, confirmed: fdata.password }" :state="validateState('password_confirmation')" aria-describedby="password_confirmation-feedback" data-vv-as="Confirm Password"></b-form-input>
                                <b-form-invalid-feedback id="password_confirmation-feedback">{{ veeErrors.first('password_confirmation') }}</b-form-invalid-feedback>
                            </b-form-group>


                            <b-form-group id="">
                                <b-button type="submit" class="login-btn mt-5" variant="primary" style="width: 260px;">Set Password</b-button>
                            </b-form-group>
                        </b-form>                 
                    </div>
                </div>
                <div class="col-md-6 login-left d-flex align-items-center position-relative">
                    <img v-bind:src="$api_url+'/images/landing-page/Abstract-Background.png'" class="login-landing-image lgn-mgt" v-if="step == 0">
                    <img v-bind:src="$api_url+'/images/landing-page/Abstract-Background.png'" class="login-landing-image lgn-emp" v-else>
                    <div class="login-left-content-wrapper">
                        <div class="accord-link text-right"><a class='atl-hr-link font-semi-bold' href="https://accordhrm.com/" target="_blank">www.accordhrm.com</a></div>
                        <div class="accord-branding-wrapper text-right">
                            <p>Welcome to</p> 
                            <img  :src="$api_url+'/images/landing-page/logo-white.png'" class="bkash-landing-image">
                        </div>
                        <p class="landing-page-intro-text">HR & Payroll solutions to suit your business</p>
                        <div class="row">
                            <div class="col-md-7">
                                <p class="d-block"><a href="tel:+880-1711-314600"><b-icon icon="telephone-fill" class="mr-1"></b-icon><span class="font-light">+880-1711-314600</span></a></p>
                                <p><a href="mailto:info@accordhrm.com"><b-icon icon="envelope-fill" class="mr-1"></b-icon><span class="font-light">info@accordhrm.com</span></a></p>
                            </div>
                            <div class="col-md-5 d-flex align-items-center justify-content-end">
                                <ul class="p-0 m-0 footer-social-icons">
                                    <li class="mr-2"><a target="_blank" href="https://www.facebook.com/accordhrm"><img  :src="$api_url+'/images/landing-page/landing-Facebook.png'" class="bkash-landing-image"></a></li>
                                    <li class="mr-2"><a target="_blank" href="https://www.linkedin.com/company/accordhrm/"><img  :src="$api_url+'/images/landing-page/landing-Linkedin.png'" class="bkash-landing-image"></a></li>
                                    <li class="mr-2"><a target="_blank" href="https://www.youtube.com/@accordhrm"><b-icon icon="youtube"></b-icon></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>   
    
</template>
 
<script>
    
    export default{
        
        mounted() {
            
        },
        props: [],
        components: {
            
        },
        data(){            
            
            return {
                                   
                successmsg:'',
                errormsg:[],
                fdata: {password:null},
                hostname: window.location.hostname,
                
            }
        },
        methods:{
            
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetvalidator()
            {
                 this.$validator.reset();
            },
            onSubmit(e) 
            {
                if(!this.checkNet()) return false;

                let submitUrl = this.$api_url + '/save-password';

                
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    e.preventDefault();  
                    let currentObj = this;

                    let formData = new FormData();
                    
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);                    
                        //console.log(`${key}: ${value}`);
                    } 

                    axios.post(submitUrl, formData)
                                .then(function (response) 
                                {
                                    
                                    this.$bvToast.toast('You will be redirected to login page now.', {
                                                title: `Password set successfully!`,
                                                variant: 'success',
                                                solid: true
                                            }); 


                                    setTimeout(function () {
                                        //this.$bvModal.hide('bv-modal-leave');
                                        window.location.href = this.$api_url; 
                                    }.bind(this), 2000);
                                    
                                }.bind(this))
                                .catch(function (error) 
                                {
                                    //alert('error');
                                    //this.errormsg = error;
                                    //currentObj.serverError(error);
                                    currentObj.$bvToast.toast('Error occured. Please try again.', {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true
                                        }); 
                                });
                });
            },            

        },
        created: function(){
            //
        }
    }
</script>